import React from 'react'
import { Path } from 'react-native-svg'

import { createIcon } from '../../_gluestack/icon'

export const LocalizationIcon = createIcon({
    viewBox: '0 0 24 24',
    path: (
        <>
            <Path
                fillRule='evenodd'
                clipRule='evenodd'
                d='M5.45251 19.8901H18.5475V21.7351H5.45251V19.8901ZM10.11 8.64014C10.11 9.15014 10.2975 9.58513 10.6725 9.94514C11.0475 10.3051 11.4938 10.4851 12.0113 10.4851C12.5288 10.4851 12.9713 10.3051 13.3388 9.94514C13.7063 9.58513 13.89 9.15014 13.89 8.64014C13.89 8.13013 13.7025 7.68764 13.3275 7.31264C12.9525 6.93763 12.51 6.75014 12 6.75014C11.49 6.75014 11.0475 6.93763 10.6725 7.31264C10.2975 7.68764 10.11 8.13013 10.11 8.64014ZM17.625 8.64014C17.625 9.42014 17.43 10.3126 17.04 11.3176C16.71 12.1726 16.245 13.0951 15.645 14.0851C15.165 14.8651 14.61 15.6751 13.98 16.5151C13.53 17.1151 13.065 17.6926 12.585 18.2476L12 18.9226L11.415 18.2476C10.935 17.6926 10.47 17.1151 10.02 16.5151C9.39001 15.6751 8.83502 14.8651 8.35501 14.0851C7.75501 13.0951 7.29002 12.1726 6.96001 11.3176C6.57001 10.3126 6.37501 9.42014 6.37501 8.64014C6.37501 7.62013 6.62626 6.67889 7.12876 5.81639C7.63127 4.95388 8.31376 4.27139 9.17626 3.76889C10.0388 3.26638 10.98 3.01514 12 3.01514C13.02 3.01514 13.9613 3.26638 14.8238 3.76889C15.6863 4.27139 16.3688 4.95388 16.8713 5.81639C17.3738 6.67889 17.625 7.62013 17.625 8.64014Z'
                fill='currentColor'
            />
        </>
    ),
})

LocalizationIcon.displayName = 'LocalizationIcon'
